module.exports = __webpack_public_path__ + "img/banner-boutiques.ee035ee8.jpeg";